import React from 'react';
import Person from './Person';
import '../../css/Team.css';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

const Team = props => {
    const personState = useSelector((state) => state.personState);
    
    const team = props.team;
    const members = team.members;

    const renderPersonComponents = (members) => {
        return members.map((member, i) => {
            const p = personState.persons[member.id];
            return <Person key={i} person={p} />
        });
    };

    let teamLeader;
    if(team.teamLeader){
        const p = personState.persons[team.teamLeader.id];
        teamLeader = <Person person={p}/>;
    }
    const style = {
        width: props.width + '%'
    };

    //subteams?
    const renderSubTeams = () => {
        if(!props.subTeams) return;
        return props.subTeams.map((x,i) => {
            return(
                <div key={i} className='subteam'>
                    <div className="divider" />
                    <h4 className="team-description">{x.name}</h4>
                    <div className="members">
                        {renderPersonComponents(x.members)}
                    </div>
                </div>
            )
        })
    };

    return (
        <div className="team" style={style}>
            <div className="inner">
                <h3 className="team-name">{team.name}</h3>
                <div className="divider" />
                <h4 className="team-description">{team.description}</h4>
                <div className="teamleader">{teamLeader}</div>
                <div className="members">
                    {renderPersonComponents(members)}
                </div>
                {renderSubTeams()}
            </div>
        </div>
    );
};

Team.propTypes = {
    team: PropTypes.object.isRequired,
    width: PropTypes.number.isRequired,
    subTeams: PropTypes.array
};

export default Team;
